import { environment } from 'src/environments/environment';
import { SapInvoiceItem } from './sap-invoice-item.class';
import { Serializable } from './serializable.class';

export class SapInvoice extends Serializable {
  public getResourceName(): string {
    return 'billing-reports/gd-billing-dashboard/invoices';
  }
  public getApiHost(): string {
    return environment.billingReportsBaseUrl;
  }
  accountId: string;
  month: number;
  year: number;
  PurchaseOrderNumber: string;
  SalesOrganization: string;
  DistributionChannel: string;
  Division: string;
  Incoterms1: string;
  Incoterms2: string;
  RequestedDeliveryDate: string;
  PurchaseOrderDate: string;
  PriceDate: string;
  BillingDate: string;
  BillingPeriodFromDate: string;
  BillingPeriodToDate: string;
  ContractStartDate: string;
  CurrencyISO: string;
  SoldToNumber: string;
  ShipToNumber: string;
  PayerNumber: string;
  BillToNumber: string;
  Items: SapInvoiceItem[];
  confirmedDate: string;
  confirmationError: string;
  SalesOrderNumber: string;
  InvoiceNumber: string;
  CustomerNumber: string;
  CustomerTaxNumber: string;
  VendorNumber: string;
  createdAt: string;
  updatedAt: string;
  status: SapInvoiceStatus;
}

export enum SapInvoiceStatus {
  DRAFT = 'draft',
  SENT = 'sent',
  CONFIRMED_WITH_ERROR = 'confirmed_with_error',
  CONFIRMED = 'confirmed',
  INVOICE_GENERATED = 'invoice_generated',
}
